<template>

  <!-- Illustration Gallery Element -->
  <q-carousel-slide
    :name="name"
    :class="classes"
    class="illustration-gallery-element">

    <page-block
      no-body
      :bg-opacity="value.bgOpacity"
      :text-color="value.textColor"
      :text-align="value.textAlign"
      :bg-color="value.bgColor || '#F5F5F7'"
      class="illustration-gallery-element__block"
      overlay-class="illustration-gallery-element__overlay"
      wrapper-class="illustration-gallery-element__wrapper">

      <div
        v-if="value.file"
        class="illustration-gallery-element__media"
        :style="{backgroundImage: `url(\'${getFileUrl(value.file)}\')`}"/>

      <div
        class="illustration-gallery-element__body">

        <div
          v-html="$u.localize(value.title)"
          class="illustration-gallery-element__title"
          v-if="$u.stripTags($u.localize(value.title))"/>

        <div
          v-html="$u.localize(value.body)"
          v-if="$u.stripTags($u.localize(value.body))"
          class="illustration-gallery-element__subtitle"/>

        <page-block-buttons
          :value="value.buttons"
          class="illustration-gallery-element__buttons"/>

      </div>

    </page-block>

  </q-carousel-slide>

</template>

<script>

  import PageBlock from '@src/components/page/page-block';
  import PageElementMixin from '@src/mixins/page-element-mixin';
  import PageBlockButtons from '@src/components/page/page-block-buttons';

  export default {
    name: 'illustration-gallery-element',
    mixins: [
      PageElementMixin,
    ],
    props: {
      value: {
        type: Object,
        required: true,
      },
      name: {
        type: Number,
        required: true,
      },
    },
    components: {
      PageBlock,
      PageBlockButtons,
    },
    computed: {
      mediaOnly() {
        return !(
          this.hasTitle &&
          this.hasBody &&
          this.hasButtons
        );
      },
      classes() {
        return {
          'media-only': this.mediaOnly,
          [this.value.textAlign]: this.value.textAlign,
        };
      },
    },
  };

</script>

<style lang="scss">

  $cls: illustration-gallery-element;

  .illustration-gallery-element {
    color: inherit;

    &__block,
    &__overlay {
      @include abs-fill;
    }

    &__wrapper {
      height: 100%;
      display: flex;
    }

    &.right {

      .#{$cls}__media {
        background-position: bottom left;
      }

      .#{$cls}__wrapper {
        justify-content: flex-end;
      }
    }

    &.center {

      .#{$cls}__media {
        background-position: bottom center;
      }

      .#{$cls}__wrapper {
        justify-content: center;
      }
    }

    &__media {
      @include abs-fill;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: bottom right;

      @media (max-width: $breakpoint-sm) {
        top: -5%;
        left: -5%;
        right: -5%;
        bottom: -5%;
        opacity: .1;
        background-size: cover;
      }
    }

    &.media-only .#{$cls}__media {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      opacity: 1;
    }

    &__body {
      display: flex;
      max-width: 50%;
      position: relative;
      flex-direction: column;
      justify-content: center;
      padding-top: $ibs-y;
      padding-left: $ibs-x * 2;
      padding-right: $ibs-x * 2;
      padding-bottom: $spacer-gg;

      @media (max-width: $breakpoint-sm) {
        max-width: none;
        padding-left: $bs-x;
        padding-right: $bs-x;
      }

      @media (max-width: $breakpoint-xs) {
        padding-left: $ibs-x;
        padding-right: $ibs-x;
      }

      p:last-child {
        margin-bottom: 0;
      }
    }

    &__title {
      font-weight: 600;
      line-height: 1.2em;
      font-size: map-get($h1, size);

      @media (max-width: $breakpoint-sm) {
        font-size: map-get($h2, size);
      }

      @media (max-width: $breakpoint-xs) {
        font-size: map-get($h3, size);
      }
    }

    &__subtitle {
      font-weight: 500;
      margin-top: $spacer-md;
      font-size: map-get($h4, size);

      @media (max-width: $breakpoint-sm) {
        margin-top: $spacer-mm;
        font-size: map-get($h6, size);
      }
    }

    &__buttons {
      margin-top: $spacer-md;

      @media (max-width: $breakpoint-sm) {
        margin-top: $spacer-sm;
      }

      & > * {
        display: block;
      }

      button {
        min-width: 60%;
        background: $brand-gradient;
      }

      .q-btn__wrapper {
        color: white;
        min-width: 100%;
      }
    }
  }

</style>
